import { Text, Button, Heading } from 'ab-uitools-legacy'

import { UseIdentification } from '../../hooks/useIdentification'

import withWrapper from '../FormWrapper'
import './index.scss'

const Identification = () => {
  const { startVerification } = UseIdentification()

  return (
    <div className="identification_container">
      <Heading className="mb-24" size="xsmall" weight="bold">
        Նույնականացում
      </Heading>
      <Text className="identification_container_content" size={'standard'}>
        Հարգելի հաճախորդ, Ձեր հարցումը նախնական հաստատվել է: Գործարքի վերջնական տրամադրման համար խնդրում ենք անցնել նույնականացում:
      </Text>

      <Button
        onClick={startVerification}
        buttonActionType="submit"
        buttonText="Սկսել"
        type="primary"
        className="start_identification_button"
      />
    </div>
  )
}

export default withWrapper(Identification)
